module.exports = __webpack_public_path__ + "media/images/icons/flags/MR-ab2cd72cdb6b789ebdc7eb70e1012947.svg";